export default __webpack_public_path__ + "static/careers-testimonials-image-3042f5fc6421480e8971b6662b714bcd.svg";